import { Accordion } from "@mantine/core";
import { useTranslation } from "react-i18next";

import FooterBackGroundImage from "../../assets/png/error-page-decoration.png";

import LinkButton from "../../components/global/Button/LinkButton/LinkButton";
import styles from "./FAQPage.module.scss";

type Question = {
  title: string;
  answer: string;
};

export const FAQPage = () => {
  const { t } = useTranslation();
  const questions: Question[] = [
    {
      title: t('faq.questions.animations.question'),
      answer: t('faq.questions.animations.answer'),
    },
    {
      title: t('faq.questions.difference.question'),
      answer: t('faq.questions.difference.answer'),
    },
    {
      title: t('faq.questions.planning.question'),
      answer: t('faq.questions.planning.answer'),
    },
    {
      title: t("faq.questions.workClothes.question"),
      answer: t("faq.questions.workClothes.answer"),
    },
    {
      title: t("faq.questions.trainees.question"),
      answer: t("faq.questions.trainees.answer"),
    },
    {
      title: t("faq.questions.difficulties.question"),
      answer: t("faq.questions.difficulties.answer"),
    },
  ];
  
  return (
    <article className={styles.faqPage}>
      <header className={styles.faqPage__headers}>
        <h1>{t("faq.title")}</h1>
        <h2>{t("faq.subtitle")}</h2>
      </header>
      <main className={styles.faqPage__questions}>
        <Accordion
          defaultValue={["question0"]}
          className={styles.faqPage__questions__accordion}
          multiple={true}
        >
          {questions.map((question, index) => {
            return (
              <Accordion.Item
                value={`question${index}`}
                key={`FAQ_question_index_${index}`}
              >
                <Accordion.Control>{question.title}</Accordion.Control>
                <Accordion.Panel>{question.answer}</Accordion.Panel>
              </Accordion.Item>
            );
          })}
        </Accordion>
      </main>
      <LinkButton to="/" text={t("buttons.backToHomePage")} />
      <footer
        style={{ backgroundImage: `url(${FooterBackGroundImage})` }}
      ></footer>
    </article>
  );
};
